import React from 'react';
import { CheckCircle2 } from 'lucide-react';
import { BookCallButton } from './BookCallButton';
export function PackageSection() {
  const includes = ['Weekly 1:1 coaching calls', 'Personalized career direction work', 'Strengths and opportunity mapping', 'Resume, LinkedIn, and positioning support', 'Networking and outreach guidance', 'Interview and professional communication coaching', 'Between-call support', 'Curated resources and local opportunities'];
  return <section id="programs" className="py-20 md:py-24 px-6 md:px-12 bg-clay/30" data-id="element-115">
      <div className="max-w-4xl mx-auto" data-id="element-116">
        <div className="text-center mb-12" data-id="element-117">
          <h2 className="text-4xl md:text-5xl font-serif mb-4" data-id="element-118">
            The Career Launch Package
          </h2>
          <p className="text-xl text-ink/80 max-w-2xl mx-auto" data-id="element-119">
            A focused 4–6 week coaching experience for recent grads who need
            help getting started.
          </p>
        </div>

        <div className="bg-white rounded-3xl p-8 md:p-12 shadow-sm border border-teal/10 relative overflow-hidden" data-id="element-120">
          <div className="absolute top-0 right-0 w-64 h-64 bg-mist rounded-full blur-3xl -translate-y-1/2 translate-x-1/3 opacity-50" data-id="element-121"></div>

          <div className="relative z-10 grid md:grid-cols-5 gap-12" data-id="element-122">
            <div className="md:col-span-3" data-id="element-123">
              <h3 className="text-2xl font-serif mb-6" data-id="element-124">What's included:</h3>
              <ul className="space-y-4" data-id="element-125">
                {includes.map((item, i) => <li key={i} className="flex items-start gap-3 text-ink/80" data-id="element-126">
                    <CheckCircle2 className="w-5 h-5 text-teal shrink-0 mt-0.5" data-id="element-127" />
                    <span data-id="element-128">{item}</span>
                  </li>)}
              </ul>
            </div>

            <div className="md:col-span-2 flex flex-col justify-center bg-ivory p-8 rounded-2xl border border-teal/5 text-center" data-id="element-129">
              <div className="mb-2 text-sm font-medium text-accent uppercase tracking-wider" data-id="element-130">
                Introductory Rate
              </div>
              <div className="text-5xl font-serif text-teal mb-4" data-id="element-131">$1,000</div>
              <p className="text-sm text-ink/60 mb-8" data-id="element-132">3 spots left!</p>
              <BookCallButton className="btn-primary w-full" data-id="element-133" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}